// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.picker_wrapper.no_alpha .picker_alpha {
  display: none
}

.picker_wrapper.no_editor .picker_editor {
  position: absolute;
  z-index: -1;
  opacity: 0
}

.picker_wrapper.no_cancel .picker_cancel {
  display: none
}

.layout_default.picker_wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: stretch;
  font-size: 10px;
  width: 25em;
  padding: .5em
}

.layout_default.picker_wrapper button,
.layout_default.picker_wrapper input {
  font-size: 1rem
}

.layout_default.picker_wrapper>* {
  margin: .5em
}

.layout_default.picker_wrapper::before {
  content: "";
  display: block;
  width: 100%;
  height: 0;
  order: 1
}

.layout_default .picker_selector,
.layout_default .picker_slider {
  padding: 1em
}

.layout_default .picker_hue {
  width: 100%
}

.layout_default .picker_sl {
  flex: 1 1 auto
}

.layout_default .picker_sl::before {
  content: "";
  display: block;
  padding-bottom: 100%
}

.layout_default .picker_editor {
  order: 1;
  width: 6.5rem
}

.layout_default .picker_editor input {
  width: 100%;
  height: 100%
}

.layout_default .picker_sample {
  order: 1;
  flex: 1 1 auto
}

.layout_default .picker_cancel,
.layout_default .picker_done {
  order: 1
}

.picker_wrapper {
  box-sizing: border-box;
  background: #f2f2f2;
  box-shadow: 0 0 0 1px silver;
  cursor: default;
  font-family: sans-serif;
  color: #444;
  pointer-events: auto
}

.picker_wrapper:focus {
  outline: 0
}

.picker_wrapper button,
.picker_wrapper input {
  box-sizing: border-box;
  border: none;
  box-shadow: 0 0 0 1px silver;
  outline: 0
}

.picker_wrapper button:active,
.picker_wrapper button:focus,
.picker_wrapper input:active,
.picker_wrapper input:focus {
  box-shadow: 0 0 2px 1px #1e90ff
}

.picker_wrapper button {
  padding: .4em .6em;
  cursor: pointer;
  background-color: #f5f5f5;
  background-image: linear-gradient(0deg, #dcdcdc, transparent)
}

.picker_wrapper button:active {
  background-image: linear-gradient(0deg, transparent, #dcdcdc)
}

.picker_wrapper button:hover {
  background-color: #fff
}

.picker_selector {
  position: absolute;
  z-index: 1;
  display: block;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border: 2px solid #fff;
  border-radius: 100%;
  box-shadow: 0 0 3px 1px #67b9ff;
  background: currentColor;
  cursor: pointer
}

.picker_slider .picker_selector {
  border-radius: 2px
}

.picker_hue {
  position: relative;
  background-image: linear-gradient(90deg, red, #ff0, #0f0, #0ff, #00f, #ff00ff, red);
  box-shadow: 0 0 0 1px silver
}

.picker_sl {
  position: relative;
  box-shadow: 0 0 0 1px silver;
  background-image: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0) 50%), linear-gradient(0deg, #000, rgba(0, 0, 0, 0) 50%), linear-gradient(90deg, grey, rgba(128, 128, 128, 0))
}

.picker_alpha,
.picker_sample {
  position: relative;
  background: linear-gradient(45deg, #d3d3d3 25%, transparent 25%, transparent 75%, #d3d3d3 75%) 0 0/2em 2em, linear-gradient(45deg, #d3d3d3 25%, #fff 25%, #fff 75%, #d3d3d3 75%) 1em 1em/2em 2em;
  box-shadow: 0 0 0 1px silver
}

.picker_alpha .picker_selector,
.picker_sample .picker_selector {
  background: 0 0
}

.picker_editor input {
  font-family: monospace;
  padding: .2em .4em
}

.picker_sample::before {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background: currentColor
}

.picker_arrow {
  position: absolute;
  z-index: -1
}

.picker_wrapper.popup {
  position: absolute;
  z-index: 2;
  margin: 1.5em
}

.picker_wrapper.popup,
.picker_wrapper.popup .picker_arrow::after,
.picker_wrapper.popup .picker_arrow::before {
  background: #f2f2f2;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, .4)
}

.picker_wrapper.popup .picker_arrow {
  width: 3em;
  height: 3em;
  margin: 0
}

.picker_wrapper.popup .picker_arrow::after,
.picker_wrapper.popup .picker_arrow::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -99
}

.picker_wrapper.popup .picker_arrow::before {
  width: 100%;
  height: 100%;
  -webkit-transform: skew(45deg);
  transform: skew(45deg);
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%
}

.picker_wrapper.popup .picker_arrow::after {
  width: 150%;
  height: 150%;
  box-shadow: none
}

.popup.popup_top {
  bottom: 100%;
  left: 0
}

.popup.popup_top .picker_arrow {
  bottom: 0;
  left: 0;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg)
}

.popup.popup_bottom {
  top: 100%;
  left: 0
}

.popup.popup_bottom .picker_arrow {
  top: 0;
  left: 0;
  -webkit-transform: rotate(90deg) scale(1, -1);
  transform: rotate(90deg) scale(1, -1)
}

.popup.popup_left {
  top: 0;
  right: 100%
}

.popup.popup_left .picker_arrow {
  top: 0;
  right: 0;
  -webkit-transform: scale(-1, 1);
  transform: scale(-1, 1)
}

.popup.popup_right {
  top: 0;
  left: 100%
}

.popup.popup_right .picker_arrow {
  top: 0;
  left: 0
}

[class*=" fpd-icon-"],
[class^=fpd-icon-] {
  font-family: FontFPD !important;
  speak: never;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.fpd-icon-eye:before {
  content: "\\e930";
  color: #485563
}

.fpd-icon-eye-hide:before {
  content: "\\e92f";
  color: #485563
}

.fpd-icon-pages:before {
  content: "\\e92e";
  color: #485563
}

.fpd-icon-remove-bg:before {
  content: "\\e92d";
  color: #485563
}

.fpd-icon-ai:before {
  content: "\\e923"
}

.fpd-icon-align-bottom:before {
  content: "\\e900";
  color: #485563
}

.fpd-icon-align-horizontal-middle:before {
  content: "\\e901";
  color: #485563
}

.fpd-icon-align-left:before {
  content: "\\e902";
  color: #485563
}

.fpd-icon-align-right:before {
  content: "\\e903";
  color: #485563
}

.fpd-icon-align-top:before {
  content: "\\e904";
  color: #485563
}

.fpd-icon-align-vertical-middle:before {
  content: "\\e905";
  color: #485563
}

.fpd-icon-back:before {
  content: "\\e906";
  color: #485563
}

.fpd-icon-bin:before {
  content: "\\e907";
  color: #485563
}

.fpd-icon-close:before {
  content: "\\e944";
  color: #485563
}

.fpd-icon-cloud-upload:before {
  content: "\\e94b";
  color: #485563
}

.fpd-icon-color:before {
  content: "\\e94c";
  color: #485563
}

.fpd-icon-copy:before {
  content: "\\e94d";
  color: #485563
}

.fpd-icon-curved-text:before {
  content: "\\e908";
  color: #485563
}

.fpd-icon-design-library:before {
  content: "\\e909";
  color: #485563
}

.fpd-icon-done:before {
  content: "\\e90a";
  color: #485563
}

.fpd-icon-download:before {
  content: "\\e90b";
  color: #485563
}

.fpd-icon-effects:before {
  content: "\\e90d";
  color: #485563
}

.fpd-icon-font-size:before {
  content: "\\e90f";
  color: #485563
}

.fpd-icon-font:before {
  content: "\\e910";
  color: #485563
}

.fpd-icon-format-align-center:before {
  content: "\\e911";
  color: #485563
}

.fpd-icon-format-align-justify:before {
  content: "\\e94e";
  color: #485563
}

.fpd-icon-format-align-left:before {
  content: "\\e94f";
  color: #485563
}

.fpd-icon-format-align-right:before {
  content: "\\e950";
  color: #485563
}

.fpd-icon-format-bold:before {
  content: "\\e951";
  color: #485563
}

.fpd-icon-format-italic:before {
  content: "\\e912";
  color: #485563
}

.fpd-icon-format-underline:before {
  content: "\\e913";
  color: #485563
}

.fpd-icon-forward:before {
  content: "\\e914";
  color: #485563
}

.fpd-icon-grid:before {
  content: "\\e915";
  color: #485563
}

.fpd-icon-guided-tour:before {
  content: "\\e916";
  color: #485563
}

.fpd-icon-images:before {
  content: "\\e917";
  color: #485563
}

.fpd-icon-info:before {
  content: "\\e918";
  color: #485563
}

.fpd-icon-layers:before {
  content: "\\e919";
  color: #485563
}

.fpd-icon-layouts:before {
  content: "\\e952";
  color: #485563
}

.fpd-icon-locked:before {
  content: "\\e953";
  color: #485563
}

.fpd-icon-magnet:before {
  content: "\\e954";
  color: #485563
}

.fpd-icon-menu:before {
  content: "\\e955";
  color: #485563
}

.fpd-icon-more:before {
  content: "\\e91a";
  color: #485563
}

.fpd-icon-move-down:before {
  content: "\\e91e";
  color: #485563
}

.fpd-icon-move-up:before {
  content: "\\e920";
  color: #485563
}

.fpd-icon-name-number:before {
  content: "\\e921";
  color: #485563
}

.fpd-icon-position:before {
  content: "\\e926";
  color: #485563
}

.fpd-icon-preview-lightbox:before {
  content: "\\e92c";
  color: #485563
}

.fpd-icon-print:before {
  content: "\\e931";
  color: #485563
}

.fpd-icon-redo:before {
  content: "\\e933";
  color: #485563
}

.fpd-icon-reset:before {
  content: "\\e956";
  color: #485563
}

.fpd-icon-rotate:before {
  content: "\\e957";
  color: #485563
}

.fpd-icon-ruler:before {
  content: "\\e958";
  color: #485563
}

.fpd-icon-save:before {
  content: "\\e959";
  color: #485563
}

.fpd-icon-text-format:before {
  content: "\\e935";
  color: #485563
}

.fpd-icon-text-input:before {
  content: "\\e939";
  color: #485563
}

.fpd-icon-text-layers:before {
  content: "\\e93d";
  color: #485563
}

.fpd-icon-text-secondary:before {
  content: "\\e93f";
  color: #485563
}

.fpd-icon-transform:before {
  content: "\\e940";
  color: #485563
}

.fpd-icon-undo:before {
  content: "\\e941";
  color: #485563
}

.fpd-icon-unlocked:before {
  content: "\\e942";
  color: #485563
}

.fpd-icon-zoom-in:before {
  content: "\\e943";
  color: #485563
}

.fpd-icon-svg:before {
  content: "\\e90c"
}

.fpd-icon-depositphotos:before {
  content: "\\e93c"
}

.fpd-icon-pixabay:before {
  content: "\\e93b"
}

.fpd-icon-text-transform:before {
  content: "\\e93a"
}

.fpd-icon-lowercase:before {
  content: "\\e937"
}

.fpd-icon-uppercase:before {
  content: "\\e938"
}

.fpd-icon-share:before {
  content: "\\e92b"
}

.fpd-icon-share-mail:before {
  content: "\\e92a"
}

.fpd-icon-share-linkedin:before {
  content: "\\e929"
}

.fpd-icon-share-pinterest:before {
  content: "\\e927"
}

.fpd-icon-share-google-plus:before {
  content: "\\e928"
}

.fpd-icon-share-facebook:before {
  content: "\\e925"
}

.fpd-icon-share-twitter:before {
  content: "\\e924"
}

.fpd-icon-corner-resize:before {
  content: "\\e922"
}

.fpd-icon-jpg:before {
  content: "\\e91b";
  color: #929292
}

.fpd-icon-pdf:before {
  content: "\\e91c";
  color: #929292
}

.fpd-icon-png:before {
  content: "\\e91d";
  color: #929292
}

.fpd-icon-qrcode:before {
  content: "\\e91f"
}

.fpd-icon-flip-vertical:before {
  content: "\\e61e";
  color: #444
}

.fpd-icon-flip-horizontal:before {
  content: "\\e61c";
  color: #444
}

.fpd-icon-fullscreen:before {
  content: "\\e949"
}

.fpd-icon-fullscreen-close:before {
  content: "\\e94a"
}

.fpd-icon-thumb-up-outline:before {
  content: "\\e947"
}

.fpd-icon-thumb-up:before {
  content: "\\e948"
}

.fpd-icon-star-outline:before {
  content: "\\e945"
}

.fpd-icon-star:before {
  content: "\\e946"
}

.fpd-icon-none:before {
  content: "\\e936"
}

.fpd-icon-crop:before {
  content: "\\e934"
}

.fpd-icon-brush:before {
  content: "\\e932"
}

.fpd-icon-photo:before {
  content: "\\e1a4"
}

.fpd-icon-arrow-dropdown:before {
  content: "\\e90e"
}

.fpd-icon-drag:before {
  content: "\\e616"
}

.fpd-icon-add:before {
  content: "\\e619"
}

.fpd-icon-reorder:before {
  content: "\\e607";
  color: #444
}

.fpd-icon-remove:before {
  content: "\\e606";
  color: #444
}

.fpd-icon-instagram:before {
  content: "\\e609";
  color: #444
}

.fpd-icon-facebook:before {
  content: "\\e608";
  color: #444
}`, "",{"version":3,"sources":["webpack://./src/assets/css/vendor.css"],"names":[],"mappings":"AAAA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,SAAS;EACT;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd;AACF;;AAEA;EACE,QAAQ;EACR;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,QAAQ;EACR;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,wCAAwC;EACxC,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,mFAAmF;EACnF;AACF;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B;AACF;;AAEA;;EAEE,kBAAkB;EAClB,gMAAgM;EAChM;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;;;EAGE,mBAAmB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX;AACF;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,SAAS;EACT,OAAO;EACP,iCAAiC;EACjC;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,MAAM;EACN,OAAO;EACP,6CAA6C;EAC7C;AACF;;AAEA;EACE,MAAM;EACN;AACF;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,+BAA+B;EAC/B;AACF;;AAEA;EACE,MAAM;EACN;AACF;;AAEA;EACE,MAAM;EACN;AACF;;AAEA;;EAEE,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF","sourcesContent":[".picker_wrapper.no_alpha .picker_alpha {\n  display: none\n}\n\n.picker_wrapper.no_editor .picker_editor {\n  position: absolute;\n  z-index: -1;\n  opacity: 0\n}\n\n.picker_wrapper.no_cancel .picker_cancel {\n  display: none\n}\n\n.layout_default.picker_wrapper {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: stretch;\n  font-size: 10px;\n  width: 25em;\n  padding: .5em\n}\n\n.layout_default.picker_wrapper button,\n.layout_default.picker_wrapper input {\n  font-size: 1rem\n}\n\n.layout_default.picker_wrapper>* {\n  margin: .5em\n}\n\n.layout_default.picker_wrapper::before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 0;\n  order: 1\n}\n\n.layout_default .picker_selector,\n.layout_default .picker_slider {\n  padding: 1em\n}\n\n.layout_default .picker_hue {\n  width: 100%\n}\n\n.layout_default .picker_sl {\n  flex: 1 1 auto\n}\n\n.layout_default .picker_sl::before {\n  content: \"\";\n  display: block;\n  padding-bottom: 100%\n}\n\n.layout_default .picker_editor {\n  order: 1;\n  width: 6.5rem\n}\n\n.layout_default .picker_editor input {\n  width: 100%;\n  height: 100%\n}\n\n.layout_default .picker_sample {\n  order: 1;\n  flex: 1 1 auto\n}\n\n.layout_default .picker_cancel,\n.layout_default .picker_done {\n  order: 1\n}\n\n.picker_wrapper {\n  box-sizing: border-box;\n  background: #f2f2f2;\n  box-shadow: 0 0 0 1px silver;\n  cursor: default;\n  font-family: sans-serif;\n  color: #444;\n  pointer-events: auto\n}\n\n.picker_wrapper:focus {\n  outline: 0\n}\n\n.picker_wrapper button,\n.picker_wrapper input {\n  box-sizing: border-box;\n  border: none;\n  box-shadow: 0 0 0 1px silver;\n  outline: 0\n}\n\n.picker_wrapper button:active,\n.picker_wrapper button:focus,\n.picker_wrapper input:active,\n.picker_wrapper input:focus {\n  box-shadow: 0 0 2px 1px #1e90ff\n}\n\n.picker_wrapper button {\n  padding: .4em .6em;\n  cursor: pointer;\n  background-color: #f5f5f5;\n  background-image: linear-gradient(0deg, #dcdcdc, transparent)\n}\n\n.picker_wrapper button:active {\n  background-image: linear-gradient(0deg, transparent, #dcdcdc)\n}\n\n.picker_wrapper button:hover {\n  background-color: #fff\n}\n\n.picker_selector {\n  position: absolute;\n  z-index: 1;\n  display: block;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  border: 2px solid #fff;\n  border-radius: 100%;\n  box-shadow: 0 0 3px 1px #67b9ff;\n  background: currentColor;\n  cursor: pointer\n}\n\n.picker_slider .picker_selector {\n  border-radius: 2px\n}\n\n.picker_hue {\n  position: relative;\n  background-image: linear-gradient(90deg, red, #ff0, #0f0, #0ff, #00f, #ff00ff, red);\n  box-shadow: 0 0 0 1px silver\n}\n\n.picker_sl {\n  position: relative;\n  box-shadow: 0 0 0 1px silver;\n  background-image: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0) 50%), linear-gradient(0deg, #000, rgba(0, 0, 0, 0) 50%), linear-gradient(90deg, grey, rgba(128, 128, 128, 0))\n}\n\n.picker_alpha,\n.picker_sample {\n  position: relative;\n  background: linear-gradient(45deg, #d3d3d3 25%, transparent 25%, transparent 75%, #d3d3d3 75%) 0 0/2em 2em, linear-gradient(45deg, #d3d3d3 25%, #fff 25%, #fff 75%, #d3d3d3 75%) 1em 1em/2em 2em;\n  box-shadow: 0 0 0 1px silver\n}\n\n.picker_alpha .picker_selector,\n.picker_sample .picker_selector {\n  background: 0 0\n}\n\n.picker_editor input {\n  font-family: monospace;\n  padding: .2em .4em\n}\n\n.picker_sample::before {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background: currentColor\n}\n\n.picker_arrow {\n  position: absolute;\n  z-index: -1\n}\n\n.picker_wrapper.popup {\n  position: absolute;\n  z-index: 2;\n  margin: 1.5em\n}\n\n.picker_wrapper.popup,\n.picker_wrapper.popup .picker_arrow::after,\n.picker_wrapper.popup .picker_arrow::before {\n  background: #f2f2f2;\n  box-shadow: 0 0 10px 1px rgba(0, 0, 0, .4)\n}\n\n.picker_wrapper.popup .picker_arrow {\n  width: 3em;\n  height: 3em;\n  margin: 0\n}\n\n.picker_wrapper.popup .picker_arrow::after,\n.picker_wrapper.popup .picker_arrow::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -99\n}\n\n.picker_wrapper.popup .picker_arrow::before {\n  width: 100%;\n  height: 100%;\n  -webkit-transform: skew(45deg);\n  transform: skew(45deg);\n  -webkit-transform-origin: 0 100%;\n  transform-origin: 0 100%\n}\n\n.picker_wrapper.popup .picker_arrow::after {\n  width: 150%;\n  height: 150%;\n  box-shadow: none\n}\n\n.popup.popup_top {\n  bottom: 100%;\n  left: 0\n}\n\n.popup.popup_top .picker_arrow {\n  bottom: 0;\n  left: 0;\n  -webkit-transform: rotate(-90deg);\n  transform: rotate(-90deg)\n}\n\n.popup.popup_bottom {\n  top: 100%;\n  left: 0\n}\n\n.popup.popup_bottom .picker_arrow {\n  top: 0;\n  left: 0;\n  -webkit-transform: rotate(90deg) scale(1, -1);\n  transform: rotate(90deg) scale(1, -1)\n}\n\n.popup.popup_left {\n  top: 0;\n  right: 100%\n}\n\n.popup.popup_left .picker_arrow {\n  top: 0;\n  right: 0;\n  -webkit-transform: scale(-1, 1);\n  transform: scale(-1, 1)\n}\n\n.popup.popup_right {\n  top: 0;\n  left: 100%\n}\n\n.popup.popup_right .picker_arrow {\n  top: 0;\n  left: 0\n}\n\n[class*=\" fpd-icon-\"],\n[class^=fpd-icon-] {\n  font-family: FontFPD !important;\n  speak: never;\n  font-style: normal;\n  font-weight: 400;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale\n}\n\n.fpd-icon-eye:before {\n  content: \"\\e930\";\n  color: #485563\n}\n\n.fpd-icon-eye-hide:before {\n  content: \"\\e92f\";\n  color: #485563\n}\n\n.fpd-icon-pages:before {\n  content: \"\\e92e\";\n  color: #485563\n}\n\n.fpd-icon-remove-bg:before {\n  content: \"\\e92d\";\n  color: #485563\n}\n\n.fpd-icon-ai:before {\n  content: \"\\e923\"\n}\n\n.fpd-icon-align-bottom:before {\n  content: \"\\e900\";\n  color: #485563\n}\n\n.fpd-icon-align-horizontal-middle:before {\n  content: \"\\e901\";\n  color: #485563\n}\n\n.fpd-icon-align-left:before {\n  content: \"\\e902\";\n  color: #485563\n}\n\n.fpd-icon-align-right:before {\n  content: \"\\e903\";\n  color: #485563\n}\n\n.fpd-icon-align-top:before {\n  content: \"\\e904\";\n  color: #485563\n}\n\n.fpd-icon-align-vertical-middle:before {\n  content: \"\\e905\";\n  color: #485563\n}\n\n.fpd-icon-back:before {\n  content: \"\\e906\";\n  color: #485563\n}\n\n.fpd-icon-bin:before {\n  content: \"\\e907\";\n  color: #485563\n}\n\n.fpd-icon-close:before {\n  content: \"\\e944\";\n  color: #485563\n}\n\n.fpd-icon-cloud-upload:before {\n  content: \"\\e94b\";\n  color: #485563\n}\n\n.fpd-icon-color:before {\n  content: \"\\e94c\";\n  color: #485563\n}\n\n.fpd-icon-copy:before {\n  content: \"\\e94d\";\n  color: #485563\n}\n\n.fpd-icon-curved-text:before {\n  content: \"\\e908\";\n  color: #485563\n}\n\n.fpd-icon-design-library:before {\n  content: \"\\e909\";\n  color: #485563\n}\n\n.fpd-icon-done:before {\n  content: \"\\e90a\";\n  color: #485563\n}\n\n.fpd-icon-download:before {\n  content: \"\\e90b\";\n  color: #485563\n}\n\n.fpd-icon-effects:before {\n  content: \"\\e90d\";\n  color: #485563\n}\n\n.fpd-icon-font-size:before {\n  content: \"\\e90f\";\n  color: #485563\n}\n\n.fpd-icon-font:before {\n  content: \"\\e910\";\n  color: #485563\n}\n\n.fpd-icon-format-align-center:before {\n  content: \"\\e911\";\n  color: #485563\n}\n\n.fpd-icon-format-align-justify:before {\n  content: \"\\e94e\";\n  color: #485563\n}\n\n.fpd-icon-format-align-left:before {\n  content: \"\\e94f\";\n  color: #485563\n}\n\n.fpd-icon-format-align-right:before {\n  content: \"\\e950\";\n  color: #485563\n}\n\n.fpd-icon-format-bold:before {\n  content: \"\\e951\";\n  color: #485563\n}\n\n.fpd-icon-format-italic:before {\n  content: \"\\e912\";\n  color: #485563\n}\n\n.fpd-icon-format-underline:before {\n  content: \"\\e913\";\n  color: #485563\n}\n\n.fpd-icon-forward:before {\n  content: \"\\e914\";\n  color: #485563\n}\n\n.fpd-icon-grid:before {\n  content: \"\\e915\";\n  color: #485563\n}\n\n.fpd-icon-guided-tour:before {\n  content: \"\\e916\";\n  color: #485563\n}\n\n.fpd-icon-images:before {\n  content: \"\\e917\";\n  color: #485563\n}\n\n.fpd-icon-info:before {\n  content: \"\\e918\";\n  color: #485563\n}\n\n.fpd-icon-layers:before {\n  content: \"\\e919\";\n  color: #485563\n}\n\n.fpd-icon-layouts:before {\n  content: \"\\e952\";\n  color: #485563\n}\n\n.fpd-icon-locked:before {\n  content: \"\\e953\";\n  color: #485563\n}\n\n.fpd-icon-magnet:before {\n  content: \"\\e954\";\n  color: #485563\n}\n\n.fpd-icon-menu:before {\n  content: \"\\e955\";\n  color: #485563\n}\n\n.fpd-icon-more:before {\n  content: \"\\e91a\";\n  color: #485563\n}\n\n.fpd-icon-move-down:before {\n  content: \"\\e91e\";\n  color: #485563\n}\n\n.fpd-icon-move-up:before {\n  content: \"\\e920\";\n  color: #485563\n}\n\n.fpd-icon-name-number:before {\n  content: \"\\e921\";\n  color: #485563\n}\n\n.fpd-icon-position:before {\n  content: \"\\e926\";\n  color: #485563\n}\n\n.fpd-icon-preview-lightbox:before {\n  content: \"\\e92c\";\n  color: #485563\n}\n\n.fpd-icon-print:before {\n  content: \"\\e931\";\n  color: #485563\n}\n\n.fpd-icon-redo:before {\n  content: \"\\e933\";\n  color: #485563\n}\n\n.fpd-icon-reset:before {\n  content: \"\\e956\";\n  color: #485563\n}\n\n.fpd-icon-rotate:before {\n  content: \"\\e957\";\n  color: #485563\n}\n\n.fpd-icon-ruler:before {\n  content: \"\\e958\";\n  color: #485563\n}\n\n.fpd-icon-save:before {\n  content: \"\\e959\";\n  color: #485563\n}\n\n.fpd-icon-text-format:before {\n  content: \"\\e935\";\n  color: #485563\n}\n\n.fpd-icon-text-input:before {\n  content: \"\\e939\";\n  color: #485563\n}\n\n.fpd-icon-text-layers:before {\n  content: \"\\e93d\";\n  color: #485563\n}\n\n.fpd-icon-text-secondary:before {\n  content: \"\\e93f\";\n  color: #485563\n}\n\n.fpd-icon-transform:before {\n  content: \"\\e940\";\n  color: #485563\n}\n\n.fpd-icon-undo:before {\n  content: \"\\e941\";\n  color: #485563\n}\n\n.fpd-icon-unlocked:before {\n  content: \"\\e942\";\n  color: #485563\n}\n\n.fpd-icon-zoom-in:before {\n  content: \"\\e943\";\n  color: #485563\n}\n\n.fpd-icon-svg:before {\n  content: \"\\e90c\"\n}\n\n.fpd-icon-depositphotos:before {\n  content: \"\\e93c\"\n}\n\n.fpd-icon-pixabay:before {\n  content: \"\\e93b\"\n}\n\n.fpd-icon-text-transform:before {\n  content: \"\\e93a\"\n}\n\n.fpd-icon-lowercase:before {\n  content: \"\\e937\"\n}\n\n.fpd-icon-uppercase:before {\n  content: \"\\e938\"\n}\n\n.fpd-icon-share:before {\n  content: \"\\e92b\"\n}\n\n.fpd-icon-share-mail:before {\n  content: \"\\e92a\"\n}\n\n.fpd-icon-share-linkedin:before {\n  content: \"\\e929\"\n}\n\n.fpd-icon-share-pinterest:before {\n  content: \"\\e927\"\n}\n\n.fpd-icon-share-google-plus:before {\n  content: \"\\e928\"\n}\n\n.fpd-icon-share-facebook:before {\n  content: \"\\e925\"\n}\n\n.fpd-icon-share-twitter:before {\n  content: \"\\e924\"\n}\n\n.fpd-icon-corner-resize:before {\n  content: \"\\e922\"\n}\n\n.fpd-icon-jpg:before {\n  content: \"\\e91b\";\n  color: #929292\n}\n\n.fpd-icon-pdf:before {\n  content: \"\\e91c\";\n  color: #929292\n}\n\n.fpd-icon-png:before {\n  content: \"\\e91d\";\n  color: #929292\n}\n\n.fpd-icon-qrcode:before {\n  content: \"\\e91f\"\n}\n\n.fpd-icon-flip-vertical:before {\n  content: \"\\e61e\";\n  color: #444\n}\n\n.fpd-icon-flip-horizontal:before {\n  content: \"\\e61c\";\n  color: #444\n}\n\n.fpd-icon-fullscreen:before {\n  content: \"\\e949\"\n}\n\n.fpd-icon-fullscreen-close:before {\n  content: \"\\e94a\"\n}\n\n.fpd-icon-thumb-up-outline:before {\n  content: \"\\e947\"\n}\n\n.fpd-icon-thumb-up:before {\n  content: \"\\e948\"\n}\n\n.fpd-icon-star-outline:before {\n  content: \"\\e945\"\n}\n\n.fpd-icon-star:before {\n  content: \"\\e946\"\n}\n\n.fpd-icon-none:before {\n  content: \"\\e936\"\n}\n\n.fpd-icon-crop:before {\n  content: \"\\e934\"\n}\n\n.fpd-icon-brush:before {\n  content: \"\\e932\"\n}\n\n.fpd-icon-photo:before {\n  content: \"\\e1a4\"\n}\n\n.fpd-icon-arrow-dropdown:before {\n  content: \"\\e90e\"\n}\n\n.fpd-icon-drag:before {\n  content: \"\\e616\"\n}\n\n.fpd-icon-add:before {\n  content: \"\\e619\"\n}\n\n.fpd-icon-reorder:before {\n  content: \"\\e607\";\n  color: #444\n}\n\n.fpd-icon-remove:before {\n  content: \"\\e606\";\n  color: #444\n}\n\n.fpd-icon-instagram:before {\n  content: \"\\e609\";\n  color: #444\n}\n\n.fpd-icon-facebook:before {\n  content: \"\\e608\";\n  color: #444\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
